/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      // NAV THINGS
      $( '.primary-menu-item__mobile' ).on( 'click', function() {
        if ( $( this ).hasClass( 'active-menu' ) ) {
          $( this ).removeClass( 'active-menu' );
        } else {
          $( '.primary-menu-item__mobile' ).each( function() {
            $( this ).removeClass( 'active-menu' );
          } );
          $( this ).addClass( 'active-menu' );
        }
      } );
      let navOpen = false;
      let current = '';
      $( '.primary-menu-item' ).on( 'click', function() {
        if ( $( this ).children( 'a' ).hasClass( 'has-children' ) ) {
          $( '.full-page-menu' ).toggleClass( 'active' );
          if ( navOpen === false ) {
            navOpen = true;
            $( '.full-page-menu' ).addClass( 'active' );
          } else if ( navOpen === true && $( this ).children( 'a' ).attr( 'id' ) != current ) {
            navOpen = true;
            $( '.full-page-menu' ).toggleClass( 'active' );
          } else {
            navOpen = false;
            $( '.full-page-menu' ).removeClass( 'active' );
          }
          current = $( this ).children( 'a' ).attr( 'id' );
        }
      } );

      $( '.menu-exit' ).on( 'click', function() {
        navOpen = false;
        $( '.full-page-menu' ).removeClass( 'active' );
        // $( '.has-children' ).each( function() {
        //   $( this ).removeClass( 'is-open' );
        //   $( this ).attr( 'aria-expanded', 'false' );
        // } );
        // $( '.mobile-children' ).each( function() {
        //   $( this ).removeClass( 'is-open' );
        //   $( this ).attr( 'aria-hidden', 'false' );
        // } );
        $( '#close-menu-btn' ).trigger( 'click' );
      } );

      // MOBILE NAV THINGS
      $( '#mobile-menu-trigger' ).on( 'click', function() {
        $( '#mobile-menu' ).toggleClass( 'active' );
        $( 'body' ).toggleClass( 'no-scroll' );
      } );

      // HEADER SEARCH BUTTON
      $( '.icon-search, .search-button.search-page' ).on( 'click', function() {
        $( 'html' ).addClass( 'searchActivated no-scroll' );
        $( 'input.hhi-search' ).focus();
      } );
      $( '.search-popup__icon-wrapper' ).on( 'click', function() {
        $( 'html' ).removeClass( 'searchActivated no-scroll' );
      } );

      // ANNOUNCEMENT BANNER
      if ( sessionStorage.getItem( 'bannerSeen' )!='true' ) {
        setTimeout( function() {
          $( '.announcement-banner' ).addClass( 'open' );
          sessionStorage.setItem( 'bannerSeen', 'true' );
        }, 500 );
      }
      $( '.annoucement-banner-exit' ).on( 'click', function() {
        $( '.announcement-banner' ).removeClass( 'open' );
      } );

      // MULTI PAGE QUOTER
      $( '#btn--start-form' ).on( 'click', function() {
        $( '.mpq-intro-page' ).css( 'opacity', '0' );
        $( '.mqp-progress-bar' ).css( 'display', 'block' );
        setTimeout( () => {
          $( '.mpq-intro-page' ).removeClass( 'active' );
        }, 700 );
      } );

      $( '.quickquote .gchoice .gfield-choice-input' ).on( 'click', function() {
        if ( $( this ).val()==='yes' ) {
          window.location.href = 'https://ondemand.3dsystems.com/user/signin';
        }
      } );

      // ON PAGE CHANGE
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const width = $( '.llgq-progress' ).width() / $( '.llgq-progress' ).parent().width() * 100;
        const widthPercentage = Math.round( width );
        $( '.llgq-current-page .progress-percentage' ).text( widthPercentage + '%' );

        $( '.mpf-skip-btn' ).on( 'click', function() {
          if ( $( '.llgq-current-page .gform_page_footer input[type="submit"]' ).length ) {
            $( '.llgq-current-page .gform_page_footer input[type="submit"]' ).trigger( 'click' );
          } else {
            $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
          }
        } );
        $( '.button[type="submit"]' ).on( 'click', function() {
          $( '.quoter-background' ).removeClass( 'quoter-background' );
          $( '.bottom-nav' ).hide();
        } );
      } );

      // FORM UPLOAD
      if ( $( '.gform_wrapper' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
          if ( $( '#input_' + formId + '_' + fieldId ).val() ) {
            const path = $( '#input_' + formId + '_' + fieldId ).val().replace( 'C:\\fakepath\\', '' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( path );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).addClass( 'has-file' );
          } else {
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( 'No file selected' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).removeClass( 'has-file' );
          }
        }, 10, 3 );
      }

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        // $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
